import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';

export const AddRequestExtensionFormModel: ISedmsFormModel = {
    evaluationSk: {
        name: 'evaluationSk',
    },
    isLocked: {
        name: 'isLocked',
    },
    reviewDate: {
        name: 'reviewDate',
    },
    extensionDays: {
        name: 'extensionDays',
        required:true
    },
    reason: {
        name: 'reason',
    },
    otherReason: {
        name: 'otherReason',
    },
    extensionDaysApproved: {
        name: 'extensionDaysApproved',
    },
    newDueByDate: {
        name: 'newDueByDate',
    },
    
    reasonForRejection: {
        name: 'reasonForRejection',
    },
    otherReasonForRejection: {
        name: 'otherReasonForRejection',
    },
    asstmtRejectionReasonOther: {
        name : 'asstmtRejectionReasonOther',
    },
    asstmtRejectionReason: {
        name : 'asstmtRejectionReason',
    }
   
}